<p-toast></p-toast>

<p-sidebar #sidebarDriverCenter
           [(visible)]="showPopup"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="handleSideBarHide()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <a style="opacity: 0.5; color: #333333; letter-spacing: -0.43px; font: normal normal bold 18px/12px Montserrat; ">Xpress Center ID: </a>
            <a style="opacity: 1; color: #333333; font: normal normal bold 18px/12px Montserrat; ">{{xpressCenter.Id}}</a>
        </div>
    </ng-template>
    <div *ngIf="xpressCenter">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 120px)'}"
                       [styleClass]="'app-scrollpanel'">
            <p-tabMenu [model]="menuItems" [activeItem]="menuItems[0]"></p-tabMenu>

            <div class="driver-center-body" *ngIf="activeTab===centerDetailsTab.Profile">
                <img *ngIf="xpressCenter.ImageUrl" class="xpress-center-image" src="{{xpressCenter.ImageUrl}}" />
                <div class="center-profile-head">Location Details</div>
                <div class="flex flex-row xpress-center-item">
                    <div class="center-primary"><a>Driver Center Name</a></div>
                    <div *ngIf="!showEditFields"><a>{{xpressCenter.Name}}</a></div>
                    <div *ngIf="showEditFields">
                        <span class="p-float-label">
                            <input type="text" pInputText [(ngModel)]="editableXpressCenter.Name">
                        </span>
                    </div>
                </div>
                <div class="flex flex-row xpress-center-item">
                    <div class="center-primary"><a>Address:</a></div>
                    <div *ngIf="!showEditFields" class="center-info-secondary"><a>{{xpressCenter.Address}}</a></div>
                    <div *ngIf="showEditFields">
                        <span class="p-float-label">
                            <input type="text" pInputText [(ngModel)]="editableXpressCenter.Address">
                        </span>
                    </div>
                </div>
                <div class="flex flex-row xpress-center-item">
                    <div class="center-primary"><a>City:</a></div>
                    <div *ngIf="!showEditFields" class="center-info-secondary"><a>{{xpressCenter.City}}</a></div>
                    <div *ngIf="showEditFields">
                        <span class="p-float-label">
                            <input type="text" pInputText [(ngModel)]="editableXpressCenter.City">
                        </span>
                    </div>
                </div>
                <div class="flex flex-row xpress-center-item">
                    <div class="center-primary"><a>Contract Start</a></div>
                    <div class="center-info-secondary"><a>{{xpressCenter.ContractStartedAtStr}}</a></div>
                </div>
                <div class="flex flex-row xpress-center-item">
                    <div class="center-primary"><a>Contract End</a></div>
                    <div class="center-info-secondary"><a>{{xpressCenter.ContractEndedAtStr}}</a></div>
                </div>
                <div class="flex flex-row xpress-center-item">
                    <div class="center-primary"><a>Monthly Rental</a></div>
                    <div *ngIf="!showEditFields" class="center-info-secondary"><a>{{xpressCenter.MonthlyRentStr}}</a></div>
                    <div *ngIf="showEditFields">
                        <p-inputNumber [(ngModel)]="editableXpressCenter.MonthlyRent"
                                       mode="currency"
                                       currency="PHP"
                                       locale="en-US"></p-inputNumber>
                    </div>
                </div>
                <div class="flex flex-row xpress-center-item">
                    <div class="center-primary"><a>CUSA Fee</a></div>
                    <div *ngIf="!showEditFields" class="center-info-secondary"><a>{{xpressCenter.CusaFeeStr}}</a></div>
                    <div *ngIf="showEditFields">
                        <p-inputNumber [(ngModel)]="editableXpressCenter.CusaFee"
                                       mode="currency"
                                       currency="PHP"
                                       locale="en-US"></p-inputNumber>
                    </div>
                </div>
                <div class="flex flex-row xpress-center-item">
                    <div class="center-primary"><a>Car park</a></div>
                    <div class="center-info-secondary"><a>{{xpressCenter.CarPark}}</a></div>
                </div>

                <div class="center-profile-head">Training Capacity</div>
                <div class="flex flex-row xpress-center-item">
                    <div class="center-primary"><a>Classroom per hour:</a></div>
                    <div class="center-info-secondary"><a>{{xpressCenter.TrainingCapacityClassroom}}</a></div>
                </div>
                <div class="flex flex-row xpress-center-item">
                    <div class="center-primary"><a>Defensive Driving p/hour</a></div>
                    <div class="center-info-secondary"><a>{{xpressCenter.TrainingCapacityDefensiveDriving}}</a></div>
                </div>

                <div class="center-profile-head">Xpress Employees</div>
                <div class="flex flex-row xpress-center-item">
                    <div class="center-primary"><a>Allocation:</a></div>
                    <div class="center-info-secondary"><a>{{xpressCenter.EmployeesCount}}</a></div>
                </div>
                <div class="flex flex-row xpress-center-item">
                    <div class="center-primary"><a>Expense:</a></div>
                    <div class="center-info-secondary"><a>{{xpressCenter.ExpensesStr}}</a></div>
                </div>
            </div>

            <div class="driver-center-body" *ngIf="activeTab===centerDetailsTab.Employees">
                <!-- Table -->
                <p-table #xpressCenterUsersGrid
                         [columns]="userCols"
                         [value]="centerUsers"
                         [resizableColumns]="true"
                         [columnResizeMode]="'expand'"
                         [autoLayout]="true"
                         [scrollable]="true"
                         [scrollHeight]="'flex'">
                    <ng-template pTemplate="header">
                        <tr>
                            <th width="70px">User</th>
                            <th *ngFor="let col of userCols"
                                pResizableColumn
                                [style.width]="col.width">
                                {{col.header}}
                            </th>
                            <th width="40px"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-centerUser>
                        <tr [pSelectableRow]="centerUser">
                            <td>
                                <p-avatar image="{{centerUser.ImageUrl}}" styleClass="mr-2" size="xlarge" shape="circle"></p-avatar>
                            </td>
                            <td *ngFor="let col of userCols"
                                class="ui-resizable-column"
                                [style.width]="col.width">
                                {{centerUser[col.field]}}
                                <ng-container *ngIf="col.isUserName"><br /><div class="center-user-email">{{centerUser.Email}}</div></ng-container>
                            </td>
                            <td>
                                <button type="button" style="background: none" pButton icon="pi pi-ellipsis-h" (click)="menuDriverCenter.toggle($event); setSelectedUser(centerUser)"></button>
                                <p-menu #menuDriverCenter [popup]="true" [model]="actionsItems" [appendTo]="'body'"></p-menu>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
                <!--Modal windows-->
                <p-dialog header="Remove Employee" [(visible)]="showDialogRemoveUser" [modal]="true" [style]="{width: '20vw'}"
                          [draggable]="false" [resizable]="false">
                    <p *ngIf="selectedUser">
                        Are you sure you want to delete the employee {{selectedUser.UserName}}?
                    </p>
                    <ng-template pTemplate="footer">
                        <p-button (click)="showDialogRemoveUser=false" label="No" styleClass="p-button-text"></p-button>
                        <p-button (click)="removeUserFromCenter()" label="Yes" styleClass="p-button-text"></p-button>
                    </ng-template>
                </p-dialog>

                <p-dialog header="Suspend Employee" [(visible)]="showDialogSuspendUser" [modal]="true" [style]="{width: '20vw'}"
                          [draggable]="false" [resizable]="false">
                    <p *ngIf="selectedUser">
                        Are you sure you want to suspend the employee {{selectedUser.UserName}}?
                    </p>
                    <ng-template pTemplate="footer">
                        <p-button (click)="showDialogSuspendUser=false" label="No" styleClass="p-button-text"></p-button>
                        <p-button (click)="suspendUser()" label="Yes" styleClass="p-button-text"></p-button>
                    </ng-template>
                </p-dialog>

                <p-dialog header="Add Employee" [(visible)]="showDialogAddUser" [modal]="true" [style]="{width: '400px', height: '370px'}"
                          [draggable]="false" [resizable]="true">
                    <div style="margin: 10px 0px;">New employees will be sent an email notifying that they assigned to center</div>

                    <div>
                        <p-dropdown [options]="freeUsers" [(ngModel)]="selectedUserToAdd" optionLabel="UserName" [filter]="true" filterBy="UserName" [showClear]="false" placeholder="Select Employee">
                            <ng-template pTemplate="selectedItem">
                                <div *ngIf="selectedUserToAdd">
                                    <div>{{selectedUserToAdd.UserName}}</div>
                                </div>
                            </ng-template>
                            <ng-template let-user pTemplate="item">
                                <div>
                                    <div>{{user.UserName}}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>
                    </div>

                    <div style="margin: 20px 0px;">
                        <p-dropdown [options]="xpressCenterRoles" [(ngModel)]="selectedUserRole" placeholder="Select Role" optionLabel="name" [showClear]="false"></p-dropdown>
                    </div>

                    <ng-template pTemplate="footer">
                        <button [disabled]="!selectedUserRole || !selectedUserToAdd || loading" pButton pRipple type="button" (click)="addEmployeeToCenter(selectedUserToAdd)"><div style="color: white">Add Employee</div></button>
                    </ng-template>
                </p-dialog>
            </div>

            <div class="driver-center-body" *ngIf="activeTab===centerDetailsTab.Expenses">

            </div>

            <div class="driver-center-body" *ngIf="activeTab===centerDetailsTab.WorkingHours">
                <p-accordion>
                    <p-accordionTab header="Operation Hours" [selected]="true">
                        <div style="margin-top: -20px">
                            <div *ngFor="let weekDay of daysOfWeek" class="flex flex-row" style="margin-bottom: 5px;">
                                <div class="driver-center-hours-margin"><p-checkbox></p-checkbox></div>
                                <div class="driver-center-hours-margin" style="width: 80px">{{weekDay.label}}</div>
                                <div>
                                    <div *ngFor="let hours of operationHours">
                                        <div class="flex flex-row">
                                            <div *ngIf="hours.DayOfWeek === weekDay.id" class="field col-4 md:col-6" style="height: 43px;">
                                                <div><label for="timeonly">Open</label></div>
                                                <div><p-calendar (onSelect)="changeOperationHours(hours)" [(ngModel)]="hours.OpenAt" [timeOnly]="true" [hourFormat]="'12'"></p-calendar></div>
                                            </div>
                                            <div *ngIf="hours.DayOfWeek === weekDay.id" class="field col-4 md:col-6" style="height: 43px;">
                                                <div><label for="timeonly">Close</label></div>
                                                <div class="flex flex-row">
                                                    <p-calendar (onSelect)="changeOperationHours(hours)" [(ngModel)]="hours.CloseAt" [timeOnly]="true" [hourFormat]="'12'"></p-calendar>
                                                    <div style="margin-left: 10px;"><button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-text" (click)="removeOperationDay(hours)"></button></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngFor="let hours of addedOperationDays">
                                        <div class="flex flex-row">
                                            <div *ngIf="hours.DayOfWeek === weekDay.id" class="field col-4 md:col-6" style="height: 43px;">
                                                <div><label for="timeonly">Open</label></div>
                                                <div><p-calendar (onSelect)="changeOperationHours(hours)" [(ngModel)]="hours.OpenAt" [timeOnly]="true" [hourFormat]="'12'"></p-calendar></div>
                                            </div>
                                            <div *ngIf="hours.DayOfWeek === weekDay.id" class="field col-4 md:col-6" style="height: 43px;">
                                                <div><label for="timeonly">Close</label></div>
                                                <div class="flex flex-row">
                                                    <p-calendar (onSelect)="changeOperationHours(hours)" [(ngModel)]="hours.CloseAt" [timeOnly]="true" [hourFormat]="'12'"></p-calendar>
                                                    <div style="margin-left: 10px;"><button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-text" (click)="removeAddedOperationDay(hours)"></button></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="isClosed(weekDay.id)" style="margin-top: 40px; width: 435px; margin-left: 15px; font-size: 16px; color: #FF0000">CLOSED</div>
                                </div>
                                <div class="driver-center-hours-margin-plus">
                                    <button pButton pRipple type="button" icon="pi pi-plus" class="p-button-rounded p-button-text" (click)="addOperationHours(weekDay.id)"></button>
                                </div>
                            </div>
                        </div>
                    </p-accordionTab>
                    <p-accordionTab header="Holiday Hours">
                        <div *ngFor="let day of holidayHours" class="flex flex-row">
                            <div class="flex flex-row" style="height: 50px; margin-left: 20px;">
                                <div class="driver-center-holiday-hours" style="width: 100px;">{{day.DayOfWeek}}</div>
                                <div class="driver-center-holiday-hours" style="width: 100px;">{{day.DateStr}}</div>
                                <div class="driver-center-holiday-hours" style="width: 250px;">{{day.OpenAt}} - {{day.CloseAt}}</div>
                                <div>
                                    <button type="button" style="background: none" pButton icon="pi pi-ellipsis-h" (click)="menuCenterHours.toggle($event); selectedHoliday = day"></button>
                                    <p-menu #menuCenterHours [popup]="true" [model]="actionsItemsHolidayHours" [appendTo]="'body'"></p-menu>
                                </div>
                            </div>
                        </div>

                        <div *ngFor="let holiday of addedHolidays" class="flex flex-row">
                            <div class="flex flex-row" style="height: 70px;">
                                <div class="driver-center-holiday-hours-margin-calendar">
                                    <div>Date</div>
                                    <p-calendar [inputStyle]="{'width':'150px'}" inputId="basic" [(ngModel)]="holiday.Date"></p-calendar>
                                </div>
                                <div class="driver-center-holiday-hours-margin-calendar">
                                    <div>Open</div>
                                    <p-calendar [inputStyle]="{'width':'100px'}" [(ngModel)]="holiday.OpenAt" [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly"></p-calendar>
                                </div>
                                <div class="driver-center-holiday-hours-margin-calendar">
                                    <div>Close</div>
                                    <p-calendar [inputStyle]="{'width':'100px'}" [(ngModel)]="holiday.CloseAt" [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly"></p-calendar>
                                </div>
                                <div class="driver-center-holiday-hours-margin-plus">
                                    <button type="button" style="background: none" pButton icon="pi pi-times" (click)="removeAddedHoliday(holiday)"></button>
                                </div>
                            </div>
                        </div>

                        <div style="margin-top: 5px; margin-left: 20px;">
                            <button pButton pRipple type="button" label="Add" class="p-button-success" (click)="addHolidayHours()"></button>
                        </div>

                        <!--Modal window-->
                        <p-dialog header="Remove Holiday" [(visible)]="showDialogRemoveHolidayDay" [modal]="true" [style]="{width: '400px', height: '200px'}"
                                  [draggable]="false" [resizable]="false">
                            <p *ngIf="selectedHoliday">
                                Are you sure you want to delete Holiday {{selectedHoliday.DateStr}}?
                            </p>
                            <ng-template pTemplate="footer">
                                <p-button (click)="showDialogRemoveHolidayDay=false" label="No" styleClass="p-button-text"></p-button>
                                <p-button (click)="removeHoliday()" label="Yes" styleClass="p-button-text"></p-button>
                            </ng-template>
                        </p-dialog>
                    </p-accordionTab>
                </p-accordion>
            </div>

            <div class="driver-center-body" *ngIf="activeTab===centerDetailsTab.Training">
                <button class="training-button" [ngClass]="{'training-button-active': activeTrainingTab === trainingDetailsTab.Classroom}"
                        (click)="activeTrainingTab = trainingDetailsTab.Classroom">
                    <div style="color: black">Classroom Training</div>
                </button>
                <button class="training-button" [ngClass]="{'training-button-active': activeTrainingTab === trainingDetailsTab.Driving}"
                        (click)="activeTrainingTab = trainingDetailsTab.Driving">
                    <div style="color: black">Defensive Driving</div>
                </button>

                <div class="driver-center-body" *ngIf="activeTrainingTab===trainingDetailsTab.Classroom">
                <div class="flex flex-row" style="margin: 30px 0px;">
                  <div style="width: 200px;" class="center-training-label">Classroom Facility</div>
                  <p-inputSwitch [(ngModel)]="xpressCenter.ClassroomFacility" (onChange)="setClassroomFacilityFalse()"></p-inputSwitch>
                </div>
                <div class="flex flex-row">
                  <div style="width: 200px;" class="center-training-label">Capacity per hour</div>
                  <p-inputNumber [disabled]="!xpressCenter.ClassroomFacility" [ngStyle]="{'margin-top': '-8px;'}" [inputStyle]="{'width':'90px'}"
                                 [(ngModel)]="xpressCenter.TrainingCapacityClassroom" (onInput)="showSaveTraining = true"></p-inputNumber>
                </div>
                <div class="flex flex-row" style="margin-top: 20px;">
                  <div style="width: 500px;" class="center-training-label">Training Sessions</div>
                  <button (click)="showAddTrainingPopup = true" pButton pRipple type="button"><div style="color: white;">Add Training</div></button>
                </div>
                <div class="flex flex-row">
                  <div style="width: 140px;">Day</div>
                  <div style="width: 140px;">Start</div>
                  <div style="width: 140px;">Finish</div>
                  <div style="width: 200px;">Repeat</div>
                </div>
                <hr style="margin: 10px 0px;" />
                <div *ngFor="let training of xpressCenterTrainingSchedule">
                  <div class="flex flex-row" style="height: 60px;">
                    <div style="width: 140px;" class="training-table-body">{{training.DayOfWeek}}</div>
                    <div style="width: 140px;" class="training-table-body">{{training.StartAt}}</div>
                    <div style="width: 140px;" class="training-table-body">{{training.FinishAt}}</div>
                    <div style="width: 200px;" class="training-table-body">{{training.Repeat}}</div>
                    <div>
                      <button type="button" style="background: none" pButton icon="pi pi-ellipsis-h" (click)="menuCenterTraining.toggle($event); selectedTraining = training"></button>
                      <p-menu #menuCenterTraining [popup]="true" [model]="actionsItemsTraining" [appendTo]="'body'"></p-menu>
                    </div>
                  </div>
                </div>
                <p-dialog header="Remove Training" [(visible)]="showDialogRemoveTraining" [modal]="true" [style]="{width: '300px', height: '200px'}"
                          [draggable]="false" [resizable]="false">
                  <p *ngIf="selectedTraining">
                    Are you sure you want to remove Training Schedule?
                  </p>
                  <ng-template pTemplate="footer">
                    <p-button (click)="showDialogRemoveTraining=false" label="No" styleClass="p-button-text"></p-button>
                    <p-button (click)="removeTraining()" label="Yes" styleClass="p-button-text"></p-button>
                  </ng-template>
                </p-dialog>

                <p-dialog header="Add Training" [(visible)]="showAddTrainingPopup" [modal]="true"
                          [style]="{width: '550px', height: '370px'}" [draggable]="false" [resizable]="false">
                  <div class="flex flex-row">
                    <p-dropdown class="driver-center-holiday-hours-margin-calendar" [options]="daysOfWeek" [(ngModel)]="addedTraining.DayOfWeek"
                                placeholder="Select Day" optionLabel="label" [showClear]="true"></p-dropdown>
                    <p-dropdown class="driver-center-holiday-hours-margin-calendar" [options]="repeatTypes" [(ngModel)]="addedTraining.Repeat"
                                placeholder="Select Repeat" optionLabel="label" [showClear]="true"></p-dropdown>
                  </div>
                  <div class="flex flex-row" style="margin-top: 20px;">
                    <div class="driver-center-holiday-hours-margin-calendar">
                      <div>Start</div>
                      <p-calendar [inputStyle]="{'width':'197px'}" [(ngModel)]="addedTraining.StartAt"
                                  [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly"></p-calendar>
                    </div>
                    <div class="driver-center-holiday-hours-margin-calendar">
                      <div>Finish</div>
                      <p-calendar [inputStyle]="{'width':'197px'}" [(ngModel)]="addedTraining.FinishAt"
                                  [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly"></p-calendar>
                    </div>
                  </div>

                  <ng-template pTemplate="footer">
                    <p-button (click)="showAddTrainingPopup=false" label="Cancel" styleClass="p-button-text"></p-button>
                    <p-button [disabled]="!addedTraining.DayOfWeek || !addedTraining.Repeat || !addedTraining.StartAt || !addedTraining.FinishAt || loading"
                              (click)="addTraining(0)" label="Add" styleClass="p-button-text"></p-button>
                  </ng-template>
                </p-dialog>
              </div>

              <div class="driver-center-body" *ngIf="activeTrainingTab===trainingDetailsTab.Driving">

              </div>
            </div>

            <div class="driver-center-body" *ngIf="activeTab===centerDetailsTab.Inventory">

            </div>
        </p-scrollPanel>
    </div>

    <div style="display: flex; position: absolute; right: 20px; bottom: 0px; z-index:3">
        <div *ngIf="activeTab === centerDetailsTab.Employees">
            <button [disabled]="showDialogRemoveUser || showDialogSuspendUser || showDialogAddUser" pButton pRipple type="button" (click)="showPopupAddEmployee()"><div style="color: white">Add Employee</div></button>
        </div>
        <div *ngIf="activeTab === centerDetailsTab.Profile && !showEditFields">
            <button pButton pRipple type="button" (click)="showEditFields = true; editableXpressCenter = xpressCenter;"><div style="color: white">Edit Details</div></button>
        </div>
        <div *ngIf="activeTab === centerDetailsTab.Profile && showEditFields">
            <button [disabled]="loading" pButton pRipple type="button" (click)="saveChanges()"><div style="color: white">Save Changes</div></button>
        </div>
        <div *ngIf="activeTab === centerDetailsTab.WorkingHours && showSaveHoliday">
            <button [disabled]="loading" pButton pRipple type="button" (click)="saveHolidayHours()"><div style="color: white">Save</div></button>
        </div>
        <div *ngIf="activeTab === centerDetailsTab.WorkingHours && showSaveOperationDays">
            <button [disabled]="loading" pButton pRipple type="button" (click)="saveOperationHoursChanges()"><div style="color: white">Save Changes</div></button>
        </div>
        <div *ngIf="activeTab === centerDetailsTab.Training && showSaveTraining">
            <button [disabled]="loading" pButton pRipple type="button" (click)="saveCapacityClassroomInfo()"><div style="color: white">Save Changes</div></button>
        </div>
    </div>
</p-sidebar>
